import React, { PropTypes, Component } from 'react';
import moment from 'moment';
import Rating from 'react-rating';
import accounting from 'accounting';
import Blazy from 'blazy';
const $ = jQuery;

class ProductGridOneExtend extends Component {
  constructor(props) {
    super(props);
    this.hideLoadingGig = this.hideLoadingGig.bind(this);
    this.state = {
      isotope: false,
    };
  }
  componentDidMount() {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
      },
    });
  }
  componentWillReceiveProps(nextProps) {
    const bLazy = new Blazy({
      success: this.hideLoadingGig,
      error: function(ele, msg) {
      },
    });    
  }
  hideLoadingGig(ele) {
    const id = this.props.post.ID;
     $('.dummyClass' + id).removeClass('lazyLoading');
  }
  componentWillMount() {
    this.setState({ isotope: this.props.block['type'] === 'isotope' ? true : false });
  }
  componentDidUpdate() {
    this.showPopup(this.props);
  }
  showPopup(props) {
    const self = this;
    const post = props.post;
    jQuery(document).ready(() => {
      jQuery('.parent-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: false,
        },
      });
      jQuery('.parent-gallery-container').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
        },
      });
    });
  }
  render() {
    let currencyPosition;
    switch(this.props.helperData.woocommerce.position) {
      case 'left':
        currencyPosition = "%s%v";
        break;
      case 'right':
        currencyPosition = "%v%s";
        break;
      case 'left_space':
        currencyPosition = "%s %v";
        break;
      case 'right_space':
        currencyPosition = "%v %s";
        break;
    }

    const currencyOptions = {
      symbol: this.props.helperData.woocommerce.symbol,
      decimal: this.props.helperData.woocommerce.decimal,
      thousand: this.props.helperData.woocommerce.thousand,
      precision: this.props.helperData.woocommerce.number,
      format: currencyPosition
    };

    const post = this.props.post;
    const view = this.props.view;
    const smallPost = post.post_excerpt.substring(0, 80);
    let imgStyle = null;
    if (this.state.isotope === false) {
      imgStyle = {
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
      };
    } else {
      imgStyle = {
        backgroundImage: 'url(' + post.thumb_url + ')',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        position: 'relative',
        width: '100%',
      };
    }
    let galleryImages = [];
    if (post.meta._product_image_gallery_links !== undefined && post.meta._product_image_gallery_links.length > 1) {
      galleryImages = post.meta._product_image_gallery_links;
    }
    const showAllGalleryImages = (item, index) => {
      return (
        <div key={'galleryImage-' + index}>
          <img src={item} alt=""/>
        </div>);
    };
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const showAttributes = (attributes, index) => {

      const attributeNo = view === 'list' ? 4 : 2;

      if(index > attributeNo){
        return false;
      }
      return (
              <li key={'metaKey-' + index}> {attributes.name }  <span>{attributes.value }</span></li>             
            );
    };

    //Generate modified url from multiple key and values start

    const productBaseUrl = post.post_link;
    const searchUrl = window.location.href;

    const uniqueKeyValues = searchUrl.split(/[?&]/).reduce(function (a, b, c) {
      const p = b.split("="), k = p[0], v = decodeURIComponent(p[1]);
      if (!p[1]) return a;
      a[k] = a[k] || [];
      a[k].push(v);
      return a;
    }, {});

    let sep = '?';
    let finalUrl = '';
    let value;

    for (let key in uniqueKeyValues) {
      value = uniqueKeyValues[key];
      finalUrl = finalUrl + sep + key + "=" + value.toString();
      sep = '&';
    }

    finalUrl = productBaseUrl.concat(finalUrl);

    post.post_link = finalUrl; 

    
    return (<div>
      { view === 'grid' ?          
        <div className="singleRoom-grid-item">
          <div className="thumbnail">
            <div className="pic-transiction">
              <picture>
                <a href={post.post_link}>
                  <source media="(min-width: 768px)" src={post.thumb_url} />
                  <img alt={post.post_title} src={post.thumb_url} />
                </a>
              </picture>
            </div>
            <div className="caption">              
              <h3><a href={post.post_link}>{post.post_title.substring(0, 30)}</a></h3>
              <p>{ post.post_content.substring(0, 70)}</p>
              <div className="singleRoom-grid-main-custom">
                <div className="row">
                  <h4><span>
                  {
                    this.props.helperData.hasOwnProperty('woocommerce') ?<span className="price" dangerouslySetInnerHTML={{ __html: accounting.formatMoney(post.meta['_price'], currencyOptions) }}></span>  : null
                  }
                  </span>&nbsp;/ Night</h4>
                  <h5> <a className="rq-btn rq-btn-secondary" href={post.post_link} >SELECT</a></h5>
                </div>
              </div>          
            </div>
          </div>        
        </div> 
      :        
        <div className="singleRoom-grid-item singleRoom-list-item">
          <div className="thumbnail"> 
            <div className="pic-transiction">           
              <picture>
                <a href={post.post_link}>
                <source media="(min-width: 768px)" src={post.thumb_url} />
                <img alt={post.post_title.substring(0, 20)} src={post.thumb_url} />
                </a>
              </picture>  
            </div>          
            <div className="caption">
              <h5 className="car-brand">{post.rnb_terms.car_company[0]}</h5>
              <h3><a href={post.post_link}>{post.post_title.substring(0, 30)}</a></h3>
              <p>{ post.post_content.substring(0, 70)}</p>
              <div className="singleRoom-grid-main-custom">
                <div className="row">
                  <h4><span>
                  {
                    this.props.helperData.hasOwnProperty('woocommerce') ?<span className="price" dangerouslySetInnerHTML={{ __html: accounting.formatMoney(post.meta['_price'], currencyOptions) }}></span>  : null
                  }
                  </span>&nbsp;/ day</h4>
                  <h5> <a className="rq-btn rq-btn-secondary" href={post.post_link}>SELECT</a></h5>
                </div>
              </div>          
            </div>
          </div>        
        </div>
    }
    </div>);
  }
}

ReactiveTemplates['ProductGridOneExtend'] = ProductGridOneExtend;





ReactiveLayouts.push( 
  {
    'key': 'ProductGridOneExtend',
    'type': 'all',
    'gridName': 'Houston',
  }
);


// WEBPACK FOOTER //
// ./assets/src/frontend/frontend.js